import { forwardRef, useState } from 'react';

import { InputText } from '@eneco/sparky';
import { InputTextProps } from '@eneco/sparky/types';
import { isValidIBAN } from 'ibantools';
import { ChangeHandler } from 'react-hook-form';


type IbanNumberInputProps = Omit<InputTextProps, 'value' | 'onChange'> & {
  onChange: ChangeHandler;
  errorMessage: string;
  showErrorMessage: boolean;
};

const IbanNumberInput = forwardRef<HTMLInputElement, IbanNumberInputProps>(
  ({ onChange: onChangeYup, name, errorMessage, defaultValue, showErrorMessage, ...props }, ref) => {
    const [internalValue, setInternalValue] = useState<string>(
      formatIban(normalizeIban(defaultValue?.toString() ?? '')),
    );

    const handleChange = (value: string) => {
      const normalizedIban = normalizeIban(value);
      const formattedIban = formatIban(normalizedIban);

      onChangeYup({ target: { value } });

      if (value.length < internalValue.length)
        // don't format text when user erases text
        setInternalValue(value);
      else setInternalValue(formattedIban);
    };

    return (
      <InputText
        ref={ref}
        name={name}
        error={showErrorMessage ? errorMessage : ''}
        onChange={event => {
          handleChange(event.target.value);
        }}
        value={internalValue}
        {...props}
      />
    );
  },
);

const formatIban = (normalizedIban: string): string =>
  (normalizedIban.match(/.{1,4}/g)?.join(' ') ?? '').toLocaleUpperCase();
export const normalizeIban = (iban: string): string => iban.replace(/\s+/g, '');
export const isValidFormattedIban = (iban: string): boolean => isValidIBAN(normalizeIban(iban));

export default IbanNumberInput;
